import { confirmAlert } from 'react-confirm-alert';

export function deleteConfirm(succes, cance) {
  confirmAlert({
    title: 'Delete confirm',
    message: 'Are you sure you want to delete element?',
    buttons: [
      {
        label: 'Yes',
        onClick: () => succes(),
      },
      {
        label: 'No',
        onClick: () => null,
      },
    ],
  });
}



// WEBPACK FOOTER //
// ./src/services/deleteConfirm.js